import React, { useState, useEffect } from 'react';
import {  Modal, Button, Spinner } from "react-bootstrap";
import API from 'api.js';
import SuggestedIcon from "../../../assets/images/images_new/suggested_ideas.svg"
import SampleIcon from "../../../assets/images/images_new/sample_response.svg"

export default function MoreAiSuggestions({
  question_id,
  hideParent = () => {},
  showParent = () => {},
}) {

	const [isOpen, setIsOpen] = useState(false);
	const [data, setData] = useState("");
	const [title, setTitle] = useState("");
  const [loadingSuggested, setLoadingSuggested] = useState(false);
  const [loadingSample, setLoadingSample] = useState(false);

	const suggestedIdeas = () => {
    setLoadingSuggested(true);
		API({
			url: "essay/suggest/keywords",
			method: "POST",
			data: {
				question_id: question_id
			}
		}).then(res => {
      hideParent();
			setIsOpen(true);
			setData(res.data.keywords);
			setTitle(res.data.title);
      setLoadingSuggested(false);
		}).finally(() => {
       setLoadingSuggested(false);
    });
	}

	const sampleResponse = () => {
    setLoadingSample(true);
		API({
			url: "essay/sample/response",
			method: "POST",
			data: {
				question_id: question_id
			}
		}).then(res => {
      hideParent();
			setIsOpen(true);
			setData(res.data.sample_response);
			setTitle(res.data.title);
      setLoadingSample(false);
		}).finally(() => {
       setLoadingSample(false);
    });
	}

	return (
    <>
      <button disabled={loadingSample} className="outline-btn-new sample-btn mx-1 "  onClick={sampleResponse}>
        {loadingSample ? <Spinner className="spinner-border me-2" size="sm" />  : null }
           <span> Sample Response </span>
           <img src={SampleIcon} alt="sample-response" />
        </button>

      <button disabled={loadingSuggested}  className="outline-btn-new suggested-btn mx-1" onClick={suggestedIdeas}>
       {loadingSuggested ? <Spinner className="spinner-border me-2" size="sm" />  : null }
        <span> Suggested Ideas </span>
        <img src={SuggestedIcon} alt="suggested-ideas" />
        </button>

      <Modal
        show={isOpen}
        size="lg"
        centered
        className="text-translate-modal unselectable pre-line p-0"
      >
        <Modal.Header className="d-flex">
          <Modal.Title className="text-translation popup_heading m-0">
            {title}
          </Modal.Title>

          <Button
            variant="link"
            className="modalClose-Btn p-0"
            onClick={() => {
              setIsOpen(false);
              showParent();
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
            >
              <path
                d="M18 6L6 18M6 6l12 12"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Button>
        </Modal.Header>
        <Modal.Body>
          <div className="custom-box">
            <div className="translate-title ">
              <span className="font-16">{data}</span>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}